import { change, getFormValues } from 'redux-form';
import { all, call, put, select, takeLatest } from 'redux-saga/effects';

import { hideLoader, showLoader } from '@topconagriculture/loader';

import api from '../../../core/api';
import { Forms } from '../../form/form.selector';
import { getFarmsListRequest } from '../farms/farms.actions';
import { composeErrorMessage } from '../../../core/helpers/utils/utils';
import { notificationError, notificationSuccess } from '../../../core/helpers/utils/notificationUtils';
import { LoadersNames } from '../../ui/ui.constants';
import { compose403ErrorMessage, successHandler } from '../../../core/helpers/utils/sagaUtils';
import { addGroupType, deleteGroupType, editGroupType, getGroupTypeList } from './groupType.actions';

export function* getGroupTypesListSaga() {
  yield put(showLoader(LoadersNames.fetchGroupTypes));
  try {
    const result = yield call(api.groupTypes.getGroupTypeList);

    yield put(
      getGroupTypeList.done({
        params: {},
        result,
      }),
    );
  } catch (err) {
    yield put(notificationError(composeErrorMessage(err)));
  }
  yield put(hideLoader(LoadersNames.fetchGroupTypes));
}

export function* addGroupTypeSaga(action: ReturnType<typeof addGroupType.started>) {
  yield put(showLoader(LoadersNames.addGroupType));
  try {
    const formName = action.payload;
    const { groupTypeName, groupClassName: id } = yield select(getFormValues(Forms.groupTypeCreationForm));
    const result = yield call(api.groupTypes.addGroupType, groupTypeName, id, formName);

    yield put(
      addGroupType.done({
        params: action.payload,
        result,
      }),
    );
    yield put(notificationSuccess('groupTypes:create_success'));
    yield put(change(Forms.groupCreationForm, 'groupType', result.id));
  } catch (err) {
    yield compose403ErrorMessage(err);
  }
  yield put(hideLoader(LoadersNames.addGroupType));
}

export function* deleteGroupTypeSaga(action: ReturnType<typeof deleteGroupType.started>) {
  yield put(showLoader(LoadersNames.deleteGroupType));
  try {
    const { id, formName } = action.payload;
    const result = yield call(api.groupTypes.deleteGroupType, id, formName);
    yield put(
      deleteGroupType.done({
        params: action.payload,
        result,
      }),
    );
    successHandler(action.meta);
    yield put(notificationSuccess('groupTypes:delete_success'));
  } catch (err) {
    yield compose403ErrorMessage(err);
  }
  yield put(hideLoader(LoadersNames.deleteGroupType));
}

export function* editGroupTypeSaga(action: ReturnType<typeof editGroupType.started>) {
  yield put(showLoader(LoadersNames.editGroupType));
  try {
    const { data, formName } = action.payload;
    const result = yield call(api.groupTypes.editGroupType, data, formName);
    yield put(
      editGroupType.done({
        params: action.payload,
        result,
      }),
    );
    yield put(notificationSuccess('groupTypes:edit_success'));
  } catch (err) {
    yield compose403ErrorMessage(err);
  }
  yield put(hideLoader(LoadersNames.editGroupType));
}

export function* watchGroupTypesSaga() {
  yield all([
    takeLatest(getGroupTypeList.started, getGroupTypesListSaga),
    takeLatest(getFarmsListRequest.done, getGroupTypesListSaga),
    takeLatest(addGroupType.started, addGroupTypeSaga),
    takeLatest(deleteGroupType.started, deleteGroupTypeSaga),
    takeLatest(editGroupType.started, editGroupTypeSaga),
  ]);
}
